import { App } from 'vue';
import {
  QueryCache,
  QueryClient,
  VueQueryPlugin,
} from '@tanstack/vue-query';

function isIgnorableDashboardQueryError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const message = String((error as { message?: unknown }).message ?? '');
  const code = String((error as { code?: unknown }).code ?? '');

  if (
    code === 'PERMISSION_DENIED' ||
    message === 'PERMISSION_DENIED' ||
    message.includes('PERMISSION_DENIED')
  ) {
    return true;
  }

  // Auth redirect is already handled by ApiService; avoid noisy console Error.
  if (message === 'Dashboard scope is not ready') {
    return true;
  }

  return false;
}

export const dashboardQueryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (isIgnorableDashboardQueryError(error)) {
        return;
      }
      // Keep a useful message in production instead of a bare `Error`.
      if (process.env.NODE_ENV !== 'production') {
        console.warn('[dashboard-query]', error);
      }
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        if (isIgnorableDashboardQueryError(error)) {
          return false;
        }
        return failureCount < 1;
      },
      gcTime: 15 * 60 * 1000,
      // Avoid deeply proxying AxiosError / API payloads (circular refs → console Error).
      shallow: true,
      throwOnError: false,
    },
  },
});

export function initVueQuery(app: App<Element>): void {
  app.use(VueQueryPlugin, { queryClient: dashboardQueryClient });
}
